import { render, staticRenderFns } from "./MyClubs.vue?vue&type=template&id=e97ee030&"
import script from "./MyClubs.vue?vue&type=script&lang=ts&"
export * from "./MyClubs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports